import { render, staticRenderFns } from "./profileeditdialog-component.vue?vue&type=template&id=54c9de8c"
import script from "./profileeditdialog-component.vue?vue&type=script&lang=ts"
export * from "./profileeditdialog-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports